var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.481,
    height: 21.989,
    viewBox: "0 0 23.481 21.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16927",
    "data-name": "Rectangle 16927",
    width: 23.481,
    height: 21.99,
    fill: "#1d1d1d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36686",
    "data-name": "Group 36686",
    transform: "translate(13748.321 5482.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36681",
    "data-name": "Group 36681",
    transform: "translate(-13748.321 -5482.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36680",
    "data-name": "Group 36680",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23165",
    "data-name": "Path 23165",
    d: "M10.046,13.36c-.445.479-.882.946-1.314,1.414L2.283,21.748a.657.657,0,0,1-.554.241c-.55-.018-1.1,0-1.729,0l9.125-9.864L.077.027C.176.018.242,0,.306,0H6.832a.39.39,0,0,1,.356.176Q10,3.945,12.815,7.706c.052.069.107.137.219.281a1.008,1.008,0,0,1,.111-.205L20.166.193A.519.519,0,0,1,20.6,0c.5.013,1.008,0,1.511,0,.076,0,.151.009.28.016l-8.474,9.16,9.572,12.792c-.116,0-.191.014-.267.014H16.743a.412.412,0,0,1-.378-.185q-3.045-4.086-6.1-8.164c-.067-.089-.135-.176-.213-.278m10.4,7.1c-.079-.113-.126-.191-.186-.266L16.122,14.67Q11.274,8.187,6.423,1.69a.393.393,0,0,0-.356-.179c-.912.008-1.823,0-2.734,0-.065,0-.126.01-.224.016.055.081.091.134.126.184l8.6,11.5q2.645,3.527,5.29,7.062a.431.431,0,0,0,.275.179c1,.013,2,.008,3.051.008",
    transform: "translate(0 -0.001)",
    fill: "#1d1d1d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6c862e87eac5c642c6826ad1fa30318b.svg";
export { ForwardRef as ReactComponent };